export default __webpack_public_path__ + "static/media/about-img.88b1b2dc.svg";